import {createRouter, createWebHistory} from 'vue-router'

import Dashboard from "@/views/Dashboard.vue";
import Register from "@/views/Register.vue";
import DashboardBonus from "@/views/Bonus.vue"
import Profile from "@/views/Profile.vue"
import EmailVerification from "@/views/EmailVerification.vue";
import Signup from "@/views/Signup.vue";
import Login from "@/views/Login.vue";
import Wishlist from "@/views/Wishlist.vue";
import ProductsViewed from "@/views/ProductsViewed.vue";
import Comments from "@/views/Comments.vue";
import Order from "@/views/Order.vue";


const routes = [
  {
    path: '/:lang(uk|ru|en)?/dashboard',
    name: 'dashboard',
    component: Dashboard
  },
  {
    path: '/:lang(uk|ru|en)?/dashboard/orders',
    name: 'orders',
    component: Dashboard
  },
  {
    path: '/:lang(uk|ru|en)?/dashboard/orders/:slug',
    name: 'order',
    component: Order
  },
  {
    path: '/:lang(uk|ru|en)?/dashboard/bonus',
    name: 'bonus',
    component: DashboardBonus
  },
  {
    path: '/:lang(uk|ru|en)?/dashboard/bonus/balance',
    name: 'bonusBalance',
    component: DashboardBonus
  },
  {
    path: '/:lang(uk|ru|en)?/dashboard/bonus/history',
    name: 'bonusHistory',
    component: DashboardBonus
  },
  {
    path: '/:lang(uk|ru|en)?/dashboard/wishlist',
    name: 'wishlist',
    component: Wishlist
  },
  {
    path: '/:lang(uk|ru|en)?/dashboard/products-viewed',
    name: 'productsViewed',
    component: ProductsViewed
  },
   {
    path: '/:lang(uk|ru|en)?/dashboard/comments',
    name: 'comments',
    component: Comments
  },
  {
    path: '/:lang(uk|ru|en)?/dashboard/profile',
    name: 'profile',
    component: Profile
  },
  {
    path: '/:lang(uk|ru|en)?/dashboard/register',
    name: 'register',
    component: Register
  },
  {
    path: '/:lang(uk|ru|en)?/dashboard/register/email-verification',
    name: 'emailVerification',
    component: EmailVerification
  },
  {
    path: '/:lang(uk|ru|en)?/dashboard/signup',
    name: 'signup',
    component: Signup
  },
  {
    path: '/:lang(uk|ru|en)?/dashboard/login',
    name: 'login',
    component: Login
  }
]

const router = createRouter({
  routes,
  history: createWebHistory()
})

export default router
